<template>
    <ion-page>
        <ion-content>
        <div class="page">
            <ion-grid class="page-content">
                <ion-row class="row-divider"></ion-row>
                <ion-row class="rectangle">
                    <ion-col>
                        <ion-row align-items-stretch>
                            <ion-col size="12" class="col-padding">
                                <!-- Below code is commented for all otp send to user only not charger -->
                                <!-- <ion-label class="light-text" v-if="dataTransfer != 'N'">Enter the OTP displayed in the Charger</ion-label>
                                <ion-label class="light-text" v-if="dataTransfer == 'N'">The OTP sent to registered mobile number</ion-label> -->
                                <ion-label class="light-text">The OTP sent to registered mobile number</ion-label>
                            </ion-col>
                        </ion-row>
                        <ion-row align-items-stretch>
                            <ion-col size="12" class="col-padding">
                                <div class="border-line">
                                    <ion-col size="12">
                                        <ion-input
                                            id="otp"
                                            type="tel"
                                            maxlength="4"
                                            autofocus
                                            v-model="otp"
                                            placeholder="* * * *"
                                            @input="otpController"
                                            class="otp-input"
                                        ></ion-input>
                                        <!-- <ion-input
                                        size="3"
                                        type="tel"
                                        autofocus="true"
                                        id="otp1"
                                        #otp1
                                        placeholder="*"
                                        required
                                        maxlength="1"
                                        @input="otp1 = $event.target.value"
                                        @keyup="otpController($event, 'otp2')"
                                        ></ion-input> -->
                                        <!-- <ion-input
                                        size="3"
                                        type="tel"
                                        id="otp2"
                                        #otp2
                                        placeholder="*"
                                        required
                                        maxlength="1"
                                        @input="otp2 = $event.target.value"
                                        @keyup="otpController($event, 'otp3')"
                                        ></ion-input> -->
                                        <!-- <ion-input
                                        size="3"
                                        type="tel"
                                        id="otp3"
                                        #otp3
                                        placeholder="*"
                                        required
                                        maxlength="1"
                                        @input="otp3 = $event.target.value"
                                        @keyup="otpController($event, 'otp4')"
                                        ></ion-input> -->
                                        <!-- <ion-input
                                        size="3"
                                        type="tel"
                                        id="otp4"
                                        #otp4
                                        placeholder="*"
                                        required
                                        maxlength="1"
                                        @input="otp4 = $event.target.value"
                                        @keyup="otpController($event, undefined)"
                                        ></ion-input> -->
                                    </ion-col>
                                </div>
                            </ion-col>
                        </ion-row>
                        <!-- Modified by Swide on 2020-12-16 Bug#1 and 10 -->
                        <ion-row v-if="counter != 0" text-center class="row-margin">
                            <ion-col>
                                <ion-label class="primary-text-link" @click="resendOtp">
                                Resend OTP
                                <span v-if="disableotp">( {{counter}} )</span>
                                </ion-label>
                            </ion-col>
                        </ion-row>
                    </ion-col>
                </ion-row>
            </ion-grid>
            <!-- <div class="spinner">
                <ion-spinner v-if="loaderTab"></ion-spinner>
            </div> -->
            
            <ion-grid>
                <ion-row>
                    <ion-col>
                        <ion-loading :is-open="isLoading" class="custom-loading" spinner="lines-sharp" message="Please Wait..."></ion-loading>
                    </ion-col>
                </ion-row>
            </ion-grid>
            
        </div>
        </ion-content>
        <div v-if="showModal" class="overlay">
                <div class="box">
                    <h4>{{ errorMessage }}</h4>

                    <div class="neon-progress-container">
                        <div
                        class="neon-progress-fill"
                        :style="{ width: progressWidth + '%' }"
                        ></div>
                    </div>

                    <p>Charger status updating</p>
                </div>
            </div>  
    </ion-page>
    
</template>

<script>
import { defineComponent } from "vue";
import { IonGrid, IonRow, IonCol, IonLabel, IonInput, IonSpinner } from "@ionic/vue";

import { EVCStationReservationService } from "../../service/evcstation/reservation.service";
import { LocalStorage } from "../../data/localstorage";
import { ToastUtils } from "../../util/toast-utils";
import { AlertUtils } from "../../util/alert-utils";
import { tryParseServiceError, migratedTryParseServiceError } from "../../service";

export default defineComponent ({
    name: 'chargingOTPVerify',
    components: {
        IonGrid, IonRow, IonCol, IonLabel, IonInput, IonSpinner
    },
    data() {
        return {
            isLoading: false,
            loaderTab: true,
            counter: 0,
            disableotp: true,
            mobile: "",
            otp: "",
            otp1: "",
            otp2: "",
            otp3: "",
            otp4: "",
            otpInd: false,
            dataTransfer: 'Y',
            durationInSeconds: '',
            waitingTime : 100,
            showModal: false,
            timeoutId: null,
            countdown: 60,
            countdownInterval: null,
            progressWidth: 0,
            interval: null,
            currentStatus: [],
            errorMessage: "",
            displayContent: false,
            durationCount: 0,
            monitorStatusInd: true,
            durationForProgressBar : 60
        }
    },
    watch: {
        showModal(newVal) {
            const headers = document.querySelectorAll('ion-header')

            headers.forEach(header => {
                header.style.pointerEvents = newVal ? 'none' : 'auto'
            })
        }
    },
    unmounted() {
        try {
        if (this.interval) {
            clearInterval(this.interval)
        }
        this.showModal = false
        } catch(error) {
        let serviceError = migratedTryParseServiceError(error);
        new ToastUtils().presentToast(serviceError.description);
        }
    },
    ionViewWillLeave() {
        if (this.interval) {
        clearInterval(this.interval)
        }
        this.showModal = false
    },

    async mounted() {
        try {
            let countForDuration = await new EVCStationReservationService().getDisplayDuration();
            this.descriptionToConfirm = countForDuration.data.additionalinfo;
            this.durationCount = parseInt(countForDuration.data.description)

            let progressBarDuration = await new EVCStationReservationService().getProgressBarDuration();
            this.durationForProgressBar = parseInt(progressBarDuration.data.description)

            this.mobile = new LocalStorage().mobile;
            this.dataTransfer = localStorage.getItem("dataTransfer");
            //Modified by Swide on 2020-12-16 Bug#1 and 10 
            //this.startCountdown(30);
            // this.setFirstFocus();
            // this.loaderTab = false;
            this.isLoading = false;
        } catch(error) {
            // this.loaderTab = false;
            this.isLoading = false;
            let serviceError = migratedTryParseServiceError(error);
            new ToastUtils().presentToast(serviceError.description);
        }
        
    },
    methods: {
        // setFirstFocus() {
        //     document.getElementById("otp1").setFocus();
        // },
        async startProgress(errorMessage) {
            this.errorMessage = errorMessage;
            this.showModal = true
            this.countdown = this.durationForProgressBar ;
            this.progressWidth = 0
            if(!this.monitorStatusInd) {
                this.interval = setInterval(() => {
                if (this.countdown > 0) {
                    this.countdown--
                    this.progressWidth = ((this.durationForProgressBar - this.countdown) / this.durationForProgressBar) * 100
                } 
                else {
                    this.monitorStatusInd = true;
                    clearInterval(this.interval)
                    clearInterval(this.toMonitorProgressbar);
                    this.closeModal()
                    setTimeout(() => {
                        this.$router.go(-1)
                    }, 100)
                }
                }, 1000);
               
            } else {
                this.monitorStatusInd = true;
                clearInterval(this.interval);
                this.closeModal()
            }
        },
        async closeModal() {
            const modal = this.$refs.confirmModal

            if (modal && modal.$el) {
                await modal.$el.dismiss()
            }

            this.showModal = false
        },
        clearMyTimeout() {
            if (this.timeOut) {
                clearTimeout(this.timeOut);
                this.timeOut = null;
                // alert("Timeout cleared before unload");
            }
        },
  
        startCountdown(seconds) {
            this.counter = seconds;
            var interval = setInterval(() => {
                this.counter--;

                if (this.counter <= 0) {
                // The code here will run when
                // the timer has reached zero.

                clearInterval(interval);
                this.disableotp = false;
                }
            }, 1000);
        },
        async resendOtp() {
            if (!this.disableotp) {
                try {
                    await new EVCStationReservationService().startChargingReservationByUser(
                        { id: this.$route.params.bookingId },
                        new LocalStorage().user
                    );
                    new ToastUtils().presentToast("OTP resent to your mobile number");
                    this.disableotp = true;
                    this.startCountdown(30);
                } catch (error) {
                    // let serviceError = tryParseServiceError(error);
                    // new AlertUtils().presentAlert(
                    //     serviceError ? serviceError : error
                    // );
                    // new ToastUtils().presentToast(error.response.data.errors[0].detail);
                    let serviceError = migratedTryParseServiceError(error);
                    new ToastUtils().presentToast(serviceError.description);
                }
            }
        },
        // async otpController(event, next) {
        //     try {
        //         if (event.target.value.length > 0) {
        //             if (next) {
        //             document.getElementById(next).setFocus();
        //             } else {
        //                 this.otp = this.otp1 + this.otp2 + this.otp3 + this.otp4;
        //                 if (this.otp.length == 4 && this.otpInd == false) {
        //                     try {
        //                         this.loaderTab = true;
        //                         this.otpInd = true;
        //                         await new EVCStationReservationService().verifyOtpForStartCharging(
        //                         this.otp,
        //                         { id: this.$route.params.bookingId },
        //                         new LocalStorage().user
        //                         );
        //                         localStorage.setItem("verifystart", "true");
        //                         this.loaderTab = false;
        //                         new ToastUtils().presentToast("Charging Initiated Successfully");
        //                         this.$router.go(-1);
        //                         /*this.$router.push({
        //                         name: "myReservationView",
        //                         params: { bookingId: this.$route.params.bookingId },
        //                         });*/
        //                     } catch(error) {
        //                         let serviceError = migratedTryParseServiceError(error);
        //                         new ToastUtils().presentToast(serviceError.description);
        //                         this.loaderTab = false;
        //                         if (serviceError.code != "CH10004") {
        //                             this.loaderTab = false;
        //                             this.$router.go(-1);
        //                         } else {
        //                             this.otpInd = false;
        //                             this.loaderTab = false;
        //                             document.getElementById("otp1").value = null;
        //                             document.getElementById("otp2").value = null;
        //                             document.getElementById("otp3").value = null;
        //                             document.getElementById("otp4").value = null;
        //                             this.otp1 = null;
        //                             this.otp2 = null;
        //                             this.otp3 = null;
        //                             this.otp4 = null;
        //                             document.getElementById("otp1").setFocus();
        //                         }
        //                     }
        //                 }
        //             }
        //         }
        //     } catch (error) {
        //         // let serviceError = tryParseServiceError(error);
        //         // new AlertUtils().presentAlert(
        //         //     serviceError ? serviceError : error
        //         // );
        //         // new ToastUtils().presentToast(error.response.data.errors[0].detail);
        //         let serviceError = migratedTryParseServiceError(error);
        //         new ToastUtils().presentToast(serviceError.description);
        //         this.loaderTab = false;
        //         //Modified by Swide on 2020-12-16 Bug#1 and 10 
        //         if (serviceError.code != "CH10004") {
        //             this.loaderTab = false;
        //             this.$router.go(-1);
        //         } else {
        //             this.otpInd = false;
        //             this.loaderTab = false;
        //             document.getElementById("otp1").value = null;
        //             document.getElementById("otp2").value = null;
        //             document.getElementById("otp3").value = null;
        //             document.getElementById("otp4").value = null;
        //             this.otp1 = null;
        //             this.otp2 = null;
        //             this.otp3 = null;
        //             this.otp4 = null;
        //             document.getElementById("otp1").setFocus();
        //         }
        //     }
        // },

        async otpController() {
            if (this.otp.length === 4 && !this.otpInd) {
            try {
                // this.loaderTab = true;
                this.isLoading = true;
                this.otpInd = true;

                await new EVCStationReservationService().verifyOtpForStartCharging(
                this.otp,
                { id: this.$route.params.bookingId },
                new LocalStorage().user
                );

                localStorage.setItem("verifystart", "true");
                new ToastUtils().presentToast("Charging Initiated Successfully");
                // this.loaderTab = false;
                this.isLoading = false;
                this.$router.go(-1);

            } catch (error) {
                let serviceError = migratedTryParseServiceError(error);
                // new ToastUtils().presentToast(serviceError.description);
                if(serviceError.code == 'US1003' || serviceError.code == 'US1004' || serviceError.code == 'US1006') {
                    if(this.monitorStatusInd) {
                    this.monitorStatusInd = false;
                    await this.startProgress(serviceError.description)
                    }
                } else {
                    await new ToastUtils().presentToast(serviceError.description);
                    this.$router.go(-1);
                }
                // this.loaderTab = false;
                this.isLoading = false;

                // if (serviceError.code !== "CH10004") {
                //     // this.$router.go(-1);
                // } else {
                //     this.otp = "";
                //     this.otpInd = false;
                //     document.getElementById("otp").setFocus();
                // }
            }
            }
        },
    },
})
</script>

<style scoped>
ion-input {
  --highlight-color-focused : none;
  --highlight-color-valid : none;
  display: inline-block;
  width: 310px;
  height: 48px;
  margin: 1px;
  --background: #ffffff;
  --padding-start: 7px;
  text-align: center;
}
.otp-input {
  letter-spacing: 10px; 
  font-size: 17px;      
  text-align: center;    
}
.neon-progress-container {
  width: 80%;
  height: 20px;
  border-radius: 50px;
  border: 2px solid #21b24b;
  padding: 3px;
  margin: 0 auto;
  /* box-shadow: 0 0 15px #00fff7; */
  background: transparent;
}

.neon-progress-fill {
  height: 100%;
  width: 0%;
  border-radius: 50px;
  background: #21b24b;
  /* box-shadow: 0 0 20px #00fff7; */
  transition: width 1s linear;
}
.overlay {
  position: fixed;
  inset: 0;                     /* top:0 right:0 bottom:0 left:0 */
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;

  z-index: 99999;               /* 🔥 very important */
}
.box {
  background: #fff;
  padding: 20px;
  border-radius: 12px;
  width: 80%;
  max-width: 350px;
  text-align: center;
}
</style>